import type { ReactNode } from 'react';

export const symbol_horizontal_align_center: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m678-450 64 64q9 8.56 9 21.78T742-342q-9 9-22.22 9-13.22 0-21.78-9L581-459q-5-5-7-10.13-2-5.14-2-11 0-5.87 2-10.87 2-5 7-10l117-117q8.56-9 21.78-9t22.22 9q9 9 9 22.22 0 13.22-9 21.78l-64 64h172q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H678ZM510-190q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-580q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v580ZM282-450H110q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q97.25-510 110-510h172l-64-64q-9-8.56-9-21.78t9-22.22q9-9 22.22-9 13.22 0 21.78 9l117 117q5 5 7 10.13 2 5.14 2 11 0 5.87-2 10.87-2 5-7 10L262-342q-8.56 9-21.78 9T218-342q-9-9-9-22.22 0-13.22 9-21.78l64-64Z"
		/>
	</svg>
);
